<template>
    <div class="banner">
        <swiper :options="swiperOptiona" ref="mySwipers" class="swiper">
            <swiper-slide class="item" v-for="(item,index) in banner" :key="index">
                 <img :src="`${global.imageUrl}${item.picurl}`" alt="">
                <div class="text">
                    <p class="p1" v-html="item.title.replace(/(\r\n|\n|\r)/gm, '<br />')"></p>
                    <p class="p2" v-html="item.description.replace(/(\r\n|\n|\r)/gm, '<br />')"></p>
                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper-pagination"></div>
        <div class="kd">
            <img src="../assets/aem/kd.png" alt="">
        </div>
        <div class="small">
            <div class="l">

            </div>
            <swiper :options="swiperOption2" ref="mySwipers2" class="swiper2">
                <swiper-slide class="item" v-for="(item,index) in banner2" :key="index">
               <div class="info">
                   <!-- <div class="pic1">
                       <img :src="`${global.imageUrl}${item.picurl}`" alt="">
                   </div> -->
                   <img class="pic2" :src="`${global.imageUrl}${item.picurl}`" alt="">
               </div>
                </swiper-slide>
            </swiper>
            <div class="r">

            </div>
        </div>
    </div>
</template>

<script>
    import {swiper, swiperSlide} from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    
    // import {getHomeInfo} from '../util/lang'
    // import '../common/jquery-1.11.3.min'
    export default {
        name: "banner",
        data() {
            let _this = this
            return {
                swiperOptiona: {
                    loop: true,
                    effect: 'fade',
                    init: false,
                    speed: 1000,
                    autoplay:false,
                    navigation: {
                        nextEl: '.btn .next',
                        prevEl: '.btn .prev',
                    },
                    pagination: {
                        el: '.banner .swiper-pagination',
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '">' +'0'+ (index + 1) + '</span>';
                        },
                    },
                },
                swiperOption2: {
                    loop: true,
                    init: false,
                    centeredSlides : true,
                    slideToClickedSlide: true,
                    speed: 1000,
                    autoplay:true,
                    slidesPerView :5,
                    breakpoints:{
                        1199:{
                            slidesPerView :1,
                        }
                    }
                }
            }
        },
        props: [
            'banner',
            'banner2'
        ],
        components: {
            swiper,
            swiperSlide,
        },
        mounted() {
            setTimeout(() => {
                this.$refs.mySwipers.swiper.init()
                this.$refs.mySwipers2.swiper.init()
                // this.$refs.mySwipers2.swiper.init();
                // const swiperTop = this.$refs.mySwipers.swiper;
                // const swiperRight = this.$refs.mySwipers2.swiper;
                // swiperTop.controller.control = swiperRight;
                // swiperRight.controller.control = swiperTop;
            },1000)
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    .banner {
        width: 100%;
        position: relative;
        transition: all 500ms;
        /*background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, .3) 100%);*/
        .swiper {
            height: 100vh;
            overflow: hidden;

            .item {
                position: relative;
                overflow: hidden;

                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                    z-index: 1;
                    cursor: pointer;
                    transform: scale(1);
                    transition: all 5s;
                }

                .text {
                    position: absolute;
                    left: 10%;
                    top:30%;
                     .p1{
                         font-family: 'SOURCEHANSANSCN-MEDIUM';
                         font-size: 50px;
                         color:white;
                         transition: all 500ms;
                         transform: translateY(100px);
                         opacity: 0;
                     }
                    .p2{
                        font-size: 30px;
                        color:white;
                        line-height: 50px;
                        margin-top: 15px;
                        text-transform: uppercase;
                        font-family: 'DINEngschriftStd';
                        transition: all 500ms;
                        transform: translateY(120px);
                        transition-delay: 200ms;
                        opacity: 0;
                    }
                    .more{
                        width: 146px;
                        height: 43px;
                        border: 1px solid rgba(249, 247, 246, .5);
                        cursor: pointer;
                        transition: all 500ms;
                        position: relative;
                        margin-top: 40px;
                        transition-delay: 400ms;
                        overflow: hidden;
                        transform: translateY(100px);
                        opacity: 0;
                        .sk{
                            color:white;
                            position: absolute;
                            left:-100%;
                            top:0;
                            width:100%;
                            line-height: 43px;
                            height:100%;
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;
                            font-size: 14px;
                            font-family: "SOURCEHANSANSCN-LIGHT";
                            transition: all 500ms;
                            background: linear-gradient(-90deg, #00A2FF 0%, #38E2FC 100%);
                            i{
                                color:white;
                            }
                        }
                        .ts{
                            color:white;
                            position: absolute;
                            left:0;
                            top:0;
                            z-index: 10;
                            width:100%;
                            line-height: 43px;
                            height:100%;
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;
                            font-size: 14px;
                            transition: all 500ms;
                            font-family: "SOURCEHANSANSCN-LIGHT";
                            i{
                                color:white;
                            }
                        }
                        &:hover{
                           .sk{
                                left:0;
                            }
                            .ts{
                                top:100%;
                            }
                        }
                    }
                }
            }

            .swiper-slide-active {
                img {
                    transform: scale(1.05);
                }

                .text {
                    .p1, .p2, .more {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            }
        }
           .kd{
               position: absolute;
               right:5.8%;
               bottom:39%;
               z-index: 100;
           }

        .small{
            position: absolute;
            left:0;
            bottom:5%;
            width:100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            z-index: 100;
            .l{
                width:24%;
                height:1px;
                background-color: rgba(255,255,255,.3);
                position: relative;
                &::after{
                    content:'';
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    background: #FFFFFF;
                    border-radius: 50%;
                    position: absolute;
                    right:-2px;
                    top:-3px;
                }
            }
            .swiper2{
                width:50%;
                .item{
                   .info{
                       position: relative;
                       height:60px;
                       display: flex;
                       flex-direction: column;
                       align-items: center;
                       justify-content: center;
                       cursor: pointer;
                       .pic1{
                           position: absolute;
                           left:0;
                           top:0;
                           width:100%;
                           height:100%;
                           display: flex;
                           flex-direction: column;
                           align-items: center;
                           justify-content: center;
                           transition: all 500ms;
                       }
                       .pic2{
                           display: inline-block;
                           max-width:100%;
                           object-fit: contain;
                           max-height: 60px;
                           opacity: 0;
                           transition: all 500ms;
                           transform: scale(0);
                       }
                   }
                }
                .swiper-slide-active{
                    .info{
                        .pic1{
                            transform: scale(0);
                            opacity: 0;
                        }
                        .pic2{
                            transform: scale(1);
                            opacity: 1;
                        }
                    }
                }
            }
            .r{
                width:24%;
                height:1px;
                background-color: rgba(255,255,255,.3);
                position: relative;
                &::after{
                    content:'';
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    background: #FFFFFF;
                    border-radius: 50%;
                    position: absolute;
                    left:-2px;
                    top:-3px;
                }
            }
        }

        @media screen and (max-width: 1000px) {
            .swiper{
              .item{
                  .text{
                      .p1{
                          font-size: 20px;
                      }
                      .p2{
                          font-size: 18px;
                          line-height: 35px;
                      }
                  }
              }
            }
        }
    }
</style>
<style scoped>
    .p2 >>> p{
        font-size: 32px;
        color:white;
        line-height: 50px;
        text-transform: uppercase;
        font-weight: lighter;
        font-family: "Helvetica-Narrow";
        transition: all 500ms;
    }
    .banner .swiper-pagination {
        bottom: 40%;
        width: 10%;
         right:3%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        height:185px;
    }

    .banner .swiper-pagination >>> .swiper-pagination-bullet {
        background-color: transparent;
        opacity: 1;
        color:rgba(255,255,255,.3);
        font-family: 'DINEngschriftStd';
        transition: all 500ms;
        position: relative;
    }
    .banner .swiper-pagination >>> .swiper-pagination-bullet:focus {
        outline: none;
    }
    .banner .swiper-pagination >>> .swiper-pagination-bullet-active{
        color:white;
        transform: scale(1.5);
    }
    @media screen and (max-width: 1000px){
        .banner .swiper-pagination{
            bottom: 41%;
            right: 12%;
        }
    }
</style>
